import * as React from 'react';
import { toAbsoluteUrl } from 'app/infrastructure/hosting';
import { Icon } from 'ui/common/icon';
import { FactLink } from 'app/area/case/components/fact-box/fact-link';
import { BadgeList } from 'ui/badge-list';
import { ComponentProps } from 'ui/common';
import { FactItemProps } from 'app/area/case/components/fact-box/types';
import { ChildEntityCountShape } from 'app/area/case/selectors';

interface FactItemCausesProps extends ComponentProps, FactItemProps {
  numberOfCauses: ChildEntityCountShape;
}

export const CausesFactItem = (props: FactItemCausesProps) => {
  const { tooltip, title, numberOfCauses, linkDomain, portalTarget } = props;
  const iconAbsolutPath = toAbsoluteUrl('i/causes-icon.svg');
  const iconCauses = <Icon url={iconAbsolutPath} />;
  const items = [
    { value: numberOfCauses?.count, tooltip }
  ];

  if (!numberOfCauses?.count) {
    return null;
  }
  return <FactLink id={props.componentId} classNames="fact-item" section={linkDomain} url={props.url} >
    <BadgeList
      icon={iconCauses}
      title={title}
      valueItems={items}
      portalTarget={portalTarget}
    />
  </FactLink>;
};
